module.exports = {
    strategy: 'ReversePercentage',
    payer: 'Player',
    rules: [
        {
            taxValue: 15,
            minApplyAmount: 0.00
        }
    ]
};
